if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super()
      this.swiper = null
    }

    connectedCallback() {
      this.gridContainer = this.querySelector('.js-recently-viewed-grid')
      this.listElements = this.gridContainer.querySelectorAll('li')
      this.swiperElement = this.querySelector('.js-swiper')
      this.init()
      this.fetchRecentlyViewed()
    }

    init() {
      const swiperNextButton = this.querySelector('.js-swiper-button-next')
      const swiperPrevButton = this.querySelector('.js-swiper-button-prev')
      if (!this.swiperElement) return
      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1.4,
        spaceBetween: 10,
        loop: false,
        lazy: true,
        mousewheel: false,
        centerInsufficientSlides: true,
        breakpoints: {
          500: {
            slidesPerView: 2.4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3.4,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 4.4,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 5.4,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: swiperNextButton,
          prevEl: swiperPrevButton,
        },
        on: {
          afterInit: () => {
            setTimeout(() => {
              swiperPrevButton.classList.remove('loading')
              swiperNextButton.classList.remove('loading')
            }, 100)
          },
        },
      })
    }

    async fetchRecentlyViewed() {
      const viewedProducts = RecentlyViewed.getProductIds()
      if (viewedProducts.length < 2) {
        this.style.display = 'none'
        return null
      }

      const url = new URL(`${Shopify.routes.root}search`, location.origin)
      url.searchParams.set('section_id', 'recently-viewed-api')
      url.searchParams.set(
        'q',
        viewedProducts.map(/** @param {string} id */ (id) => `id:${id}`).join(' OR '),
      )
      url.searchParams.set('resources[type]', 'product')
      const requestUrl = url.origin + url.pathname + url.search
      fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText
          this.renderRecentlyViewed(html)
        })
    }

    renderRecentlyViewed(html) {
      let parser = new DOMParser()
      let doc = parser.parseFromString(html, 'text/html')

      let swiperIndex = 0
      RecentlyViewed.getProducts().forEach((product) => {
        const productCard = doc.querySelector(
          `rebuilt-product-card[data-product-id="${product.id}"]`,
        )
        if (productCard) {
          const li = document.createElement('li')
          li.innerHTML = productCard.outerHTML
          this.listElements[swiperIndex].classList.remove('recently-viewed__skeleton')
          this.listElements[swiperIndex].innerHTML = li.innerHTML
          swiperIndex++
        }
      })

      this.removeRemainingSkeletons()
    }

    removeRemainingSkeletons() {
      this.listElements.forEach((element) => {
        if (element.classList.contains('recently-viewed__skeleton')) {
          element.remove()
        }
      })
    }
  }
  customElements.define('recently-viewed-products', RecentlyViewedProducts)
}
